import { InvoicePosition } from '@shared/models/invoice-position';

export type SlipVoucherPositionSourceKind = 'order' | 'booking';

export function formatOrderDisplayNumber(orderId: number): string {
    return `#${String(orderId).padStart(4, '0')}`;
}

export function resolveSlipVoucherPositionSourceKind(
    position: Pick<InvoicePosition, 'bcm_orders_id' | 'bcm_bookings_id'>,
): SlipVoucherPositionSourceKind | null {
    if (position.bcm_orders_id) {
        return 'order';
    }

    if (position.bcm_bookings_id) {
        return 'booking';
    }

    return null;
}

export function resolveSlipVoucherPositionSourceId(
    position: Pick<InvoicePosition, 'bcm_orders_id' | 'bcm_bookings_id'>,
): number | null {
    const kind = resolveSlipVoucherPositionSourceKind(position);

    if (kind === 'order') {
        return position.bcm_orders_id ?? null;
    }

    if (kind === 'booking') {
        return position.bcm_bookings_id ?? null;
    }

    return null;
}

export function resolveSlipVoucherPositionSourceLabelKey(
    position: Pick<InvoicePosition, 'bcm_orders_id' | 'bcm_bookings_id'>,
): string | null {
    const kind = resolveSlipVoucherPositionSourceKind(position);

    if (kind === 'order') {
        return 'bcmInvoicePositionsTable.source.order';
    }

    if (kind === 'booking') {
        return 'bcmInvoicePositionsTable.source.booking';
    }

    return null;
}
